﻿﻿export interface IPendingSwapRecipient {
    id: number;
    alias: string;
    centerId: number;
    centerAlias: string;
    aboUploadPath: string;
    demographicsUploadPath: string;
    rawTypingUploadPath: string;
    kidneyArrivalDateTime: string;
    isInChip: boolean;
    isTransplanted: boolean;
}
